import { useBlocker } from '@tanstack/react-router';
import { memo } from 'react';
import {
    Button,
    Dialog,
    DialogActions,
    DialogBody,
    DialogContent,
    DialogSurface,
    DialogTitle,
    useId,
} from '@fluentui/react-components';
import { CheckmarkRegular, DismissRegular } from '@fluentui/react-icons';

export const NavigationBlocker = memo<{
    useData: (ignoreIfNew?: boolean) => Record<string, any> | undefined | null;
    useIsDirty: () => boolean;
}>((props) => {
    const data = props.useData();
    const isDirty = props.useIsDirty();
    const { proceed, reset, status } = useBlocker({
        shouldBlockFn: () => !data || isDirty,
        withResolver: true,
    });
    const dlgId = useId('dialog-');
    const dlgTitleId = dlgId + '-title';
    const dlgContentId = dlgId + '-content';

    return (
        status === 'blocked' && (
            <Dialog
                onOpenChange={(_event, data) => {
                    if (!data.open) {
                        reset();
                    }
                }}
                open={true}
                surfaceMotion={null}
            >
                <DialogSurface aria-labelledby={dlgTitleId} aria-describedby={dlgContentId}>
                    <DialogBody>
                        <DialogTitle id={dlgTitleId}>Ungespeicherte Änderungen</DialogTitle>

                        <DialogContent id={dlgContentId}>
                            Es liegen ungespeicherte Änderungen vor. Möchten Sie fortfahren? Beim
                            Fortfahren gehen Anderungen verloren.
                        </DialogContent>

                        <DialogActions>
                            <Button
                                appearance="primary"
                                icon={<CheckmarkRegular />}
                                onClick={proceed}
                            >
                                Fortfahren
                            </Button>

                            <Button
                                appearance="secondary"
                                icon={<DismissRegular />}
                                onClick={reset}
                            >
                                Abbrechen
                            </Button>
                        </DialogActions>
                    </DialogBody>
                </DialogSurface>
            </Dialog>
        )
    );
});
